// #region focus
export var TagEnum;
(function (TagEnum) {
    TagEnum["radio"] = "radio";
    TagEnum["input"] = "input";
    TagEnum["select"] = "select";
    TagEnum["checkbox"] = "checkbox";
})(TagEnum || (TagEnum = {}));
// #endregion focus
